// extracted by mini-css-extract-plugin
module.exports = {"templateCard":"TemplateCard_templateCard__qNJ0p","imageContainers":"TemplateCard_imageContainers__JK3qx","templateCardContent":"TemplateCard_templateCardContent__3S9dE"};